<template>
  <div style="height: 500px">
    <b-modal id="editIntegration" scrollable hide-footer hide-header size="lg">
      <EditIntegModal />
    </b-modal>
    <b-modal
      id="syncIntegrationConfirmModal"
      scrollable
      hide-footer
      hide-header
      size="lg"
    >
      <SyncIntegModal />
    </b-modal>

    <div
      class="d-flex loading-container"
      v-if="getSyncStatusStage == 'processing'"
    >
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="loader-content">
        <p>{{ getSyncStatusText }}</p>
        <span class="count">{{ getSyncStatusmsg }}</span>
      </div>
    </div>
    <!-- <div
      class="d-flex loading-container"
      v-if="getMigrateStatusStage == 'processing'"
    >
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="loader-content">
        <p>{{ getMigrateStatusText }}</p>
        <span class="count">{{ getMigrateStatusmsg }}</span>
      </div>
    </div> -->
    <div
      class="loading-container d-flex justify-content-center"
      v-if="getSyncStatusStage == 'failed'"
    >
      <div class="centerd">
        <h5 class="d-flex justify-content-center">{{ getSyncStatusText }}</h5>
        <div class="action-btns">
          <button
            class="submit-btn btn btn-primary"
            size="md"
            @click="
              retrySync({ id: getIntegId, isFailed: true, syncId: getSyncId })
            "
          >
            <span class="btn-text">{{ getSyncStatusmsg }}</span>
          </button>
        </div>
      </div>
    </div>

    <div
      class="loading-container d-flex justify-content-center align-items-center"
      v-if="getSyncStatusStage == 'auth-failed'"
    >
      <div class="center">
        <h6
          class="d-flex justify-content-center"
          style="margin-bottom: 10px !important"
        >
          {{ getSyncStatusText }}
        </h6>
        <p class="reauthenticate">
          {{ getSyncStatusmsg }}
        </p>
        <div class="action-btns">
          <router-link
            :to="`/view-integration/${getIntegId}/${getIntgData.name}`"
          >
            <button class="submit-btn btn btn-primary" size="md">
              <span class="btn-text">Back</span>
            </button>
          </router-link>
        </div>
      </div>
    </div>
    <PageHeader
      className="d-flex align-items-center justify-content-between"
      v-if="getSyncStatusStage == 'done'"
    >
    </PageHeader>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import PageHeader from "@/components/page-header";
// import DataTable from "@/components/grid/DataTable";
import EditIntegModal from "@/components/integration/EditIntegrationModal";
import SyncIntegModal from "@/components/integration/SyncIntegrationModal";
export default {
  components: {
    PageHeader,
    EditIntegModal,
    // DataTable,
    SyncIntegModal,
  },
  data() {
    return {
      isLoading: true,
    };
  },
  methods: {
    ...mapActions("integration", [
      "startFirstSync",
      "StartSyncUsers",
      "retrySync",
      "fetchSyncUsersJobStatus",
    ]),
  },
  mounted() {
    console.log("this.getSyncDestroyed", this.getSyncDestroyed);
    // if (this.getSyncDestroyed)
    // this.fetchSyncUsersJobStatus(this.getIntegId);
  },
  created() {
    window.addEventListener("beforeunload", () => {
      // detect refresh
      this.$store.commit("integration/setSyncDestroyed", true);
    });
  },
  destroyed() {
    // detect navigation away
    this.$store.commit("integration/setSyncDestroyed", true);
  },
  computed: {
    ...mapGetters("integration", [
      "getLoading",
      "getSyncStatusText",
      "getSyncStatusStage",
      "getSyncStatusmsg",
      "getValidUsers",
      "getValidUsersCount",
      "getMigrateStatusText",
      "getMigrateStatusStage",
      "getMigrateStatusmsg",
      "getIntegId",
      "getIntgData",
      "getSyncId",
      "getSyncDestroyed",
    ]),
    rowsData() {
      return this.getValidUsers && this.getValidUsers.length > 0
        ? this.getValidUsers.map((el) => {
            return {
              id: el.id,
              fullName: el.first_name + el.last_name,
              emailAddress: el.email,
              phoneNumber: el.phone,
              RFID: el.dir_int_type,
              userType: JSON.parse(JSON.stringify(el.user_type)),
            };
          })
        : [];
    },
  },
  beforeMount() {
    // this.fetchValidTempUsers();
  },
};
</script>
<style lang="scss" scoped>
.loading-container {
  position: absolute;
  top: 300px;
  inset-inline-start: 30%;
  background-color: white;
  align-items: center;
  border-radius: 60px !important;
  min-width: 291px;
  margin-top: 0px !important;
  padding: 20px 30px;
  // min-height: 121px;

  h6,
  h5 {
    font-weight: 700;
    font-size: 16px;
    line-height: 152%;
    color: #000000;
    padding: 0px !important;
    margin-bottom: 20px;
    // margin-top: 25px!important;
  }

  p {
    margin-top: 5px;
    font-weight: 700;
    font-size: 16px;
    color: #000000;
    margin-bottom: 6px;
    line-height: 152%;
  }
  span.count {
    font-weight: 600;
    color: #787878;
    font-size: 14px;
    line-height: 152%;
  }
  .submit-btn {
    margin-inline-end: 0px;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    text-align: center;

    color: #ffffff;
  }
  .btn-text {
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: #ffffff;
  }
  p.reauthenticate {
    font-weight: 600;
    font-size: 14px;
    line-height: 152%;
    color: #787878;
    margin-bottom: 20px;
  }
}
.spinner-border {
  color: #103f5e;
  border-width: 0.35em;
  width: 38px;
  height: 38px;
  margin-inline-end: 22px;
  margin-inline-start: 31px;
  border-right-color: #d9d9d9;
}
.white-bg-sec {
  background-color: white;
  padding-inline-start: 30px;
  padding-top: 32px;
}

.error-count {
  h5 {
    color: #939393;
    font-weight: bold;
    font-size: 20px;
  }
  span {
    background-color: #103f5e;
    color: white;
    // padding: 3px 13px;
    font-size: 16px;
    border-radius: 15.5px;
    margin-inline-start: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
p {
  display: block;
  color: #939393;
}
.grid-wrapper.border {
  border: 0px !important;
}
.table thead th {
  color: #939393;
  background-color: #f8f9fa;
  border-radius: 5px;
  border-bottom: 0px;
}
.table th,
.table td {
  border-top: 0px;
}
</style>
